<template>
    <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][bettyp]">
        <div data-template="template5" class="wrap-template template5">
            <div>
                <div class="main-handicap">
                    <div class="vrow items-center template-title is_fold">
                        <div class="play-name col" @click="showLeg()">
                            <span class="ellipsis">{{ sportAllBetLang['ALL_BET.SUBHEADER_WD'] }}</span>
                        </div>
                        <div style="width: 37px;" @click="setToTop($event)">
                            <span class="set_top" style="display: none;">
                                <i data-v-082e727f="" aria-hidden="true" role="presentation"
                                    class="q-icon icon-set_top c-icon"></i>
                            </span>
                        </div>
                    </div>
                    <template v-if="show">
                        <template
                            v-for="(subMatch, subMatchKey) in (Object.keys(newAllBetEvent.od[plytyp][bettyp]).length)">
                            <template
                                v-if="newAllBetEvent.od[plytyp][bettyp][Object.keys(newAllBetEvent.od[plytyp][bettyp])[subMatchKey]]">
                                <template v-if="subMatchKey == 0">
                                    <div class="vrow sub-title-1">
                                        <span style="width: 25%;"></span>
                                        <span style="width: 37.5%; text-align: center;" v-html="newAllBetEvent.tacapt"></span>
                                        <span style="width: 37.5%; text-align: center;" v-html="newAllBetEvent.tbcapt"></span>
                                    </div>
                                    <div class="handicap">
                                        <div class="handicap-item sub-title-2 yb-family-odds">
                                            {{ sportAllBetLang['ALL_BET.LBL_WIN_BY_1T5'] }}
                                        </div>
                                        <div class="handicap-item os-1 os-wd">
                                            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid2">
                                                <div class="bet-inner yb-flex-center fit">
                                                    <div class="handicap-wrap">
                                                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                                                            <span class="handicap-more" style="display: none;"></span>
                                                            <div class="ellipsis"></div>
                                                        </div>
                                                    </div>
                                                    <cstgftht :event="newAllBetEvent" :score="'h_1_5'" :plyType="plytyp" :betType="bettyp" ref="h_1_5" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="handicap-item os-1">
                                            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid2">
                                                <div class="bet-inner yb-flex-center fit">
                                                    <div class="handicap-wrap">
                                                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                                                            <span class="handicap-more" style="display: none;"></span>
                                                            <div class="ellipsis"></div>
                                                        </div>
                                                    </div>
                                                    <cstgftht :event="newAllBetEvent" :score="'a_1_5'" :plyType="plytyp" :betType="bettyp" ref="a_1_5" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="handicap">
                                        <div class="handicap-item sub-title-2 yb-family-odds">
                                            {{ sportAllBetLang['ALL_BET.LBL_WIN_BY_6T10'] }}
                                        </div>
                                        <div class="handicap-item os-1 os-wd">
                                            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid2">
                                                <div class="bet-inner yb-flex-center fit">
                                                    <div class="handicap-wrap">
                                                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                                                            <span class="handicap-more" style="display: none;"></span>
                                                            <div class="ellipsis"></div>
                                                        </div>
                                                    </div>
                                                    <cstgftht :event="newAllBetEvent" :score="'h_6_10'" :plyType="plytyp" :betType="bettyp" ref="h_6_10" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="handicap-item os-1">
                                            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid2">
                                                <div class="bet-inner yb-flex-center fit">
                                                    <div class="handicap-wrap">
                                                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                                                            <span class="handicap-more" style="display: none;"></span>
                                                            <div class="ellipsis"></div>
                                                        </div>
                                                    </div>
                                                    <cstgftht :event="newAllBetEvent" :score="'a_6_10'" :plyType="plytyp" :betType="bettyp" ref="a_6_10" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="handicap">
                                        <div class="handicap-item sub-title-2 yb-family-odds">
                                            {{ sportAllBetLang['ALL_BET.LBL_WIN_BY_11T15'] }}
                                        </div>
                                        <div class="handicap-item os-1 os-wd">
                                            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid2">
                                                <div class="bet-inner yb-flex-center fit">
                                                    <div class="handicap-wrap">
                                                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                                                            <span class="handicap-more" style="display: none;"></span>
                                                            <div class="ellipsis"></div>
                                                        </div>
                                                    </div>
                                                    <cstgftht :event="newAllBetEvent" :score="'h_11_15'" :plyType="plytyp" :betType="bettyp" ref="h_11_15" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="handicap-item os-1">
                                            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid2">
                                                <div class="bet-inner yb-flex-center fit">
                                                    <div class="handicap-wrap">
                                                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                                                            <span class="handicap-more" style="display: none;"></span>
                                                            <div class="ellipsis"></div>
                                                        </div>
                                                    </div>
                                                    <cstgftht :event="newAllBetEvent" :score="'a_11_15'" :plyType="plytyp" :betType="bettyp" ref="a_11_15" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="handicap">
                                        <div class="handicap-item sub-title-2 yb-family-odds">
                                            {{ sportAllBetLang['ALL_BET.LBL_WIN_BY_16T20'] }}
                                        </div>
                                        <div class="handicap-item os-1 os-wd">
                                            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid2">
                                                <div class="bet-inner yb-flex-center fit">
                                                    <div class="handicap-wrap">
                                                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                                                            <span class="handicap-more" style="display: none;"></span>
                                                            <div class="ellipsis"></div>
                                                        </div>
                                                    </div>
                                                    <cstgftht :event="newAllBetEvent" :score="'h_16_20'" :plyType="plytyp" :betType="bettyp" ref="h_16_20" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="handicap-item os-1">
                                            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid2">
                                                <div class="bet-inner yb-flex-center fit">
                                                    <div class="handicap-wrap">
                                                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                                                            <span class="handicap-more" style="display: none;"></span>
                                                            <div class="ellipsis"></div>
                                                        </div>
                                                    </div>
                                                    <cstgftht :event="newAllBetEvent" :score="'a_16_20'" :plyType="plytyp" :betType="bettyp" ref="a_16_20" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="handicap">
                                        <div class="handicap-item sub-title-2 yb-family-odds">
                                            {{ sportAllBetLang['ALL_BET.LBL_WIN_BY_21T25'] }}
                                        </div>
                                        <div class="handicap-item os-1 os-wd">
                                            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid2">
                                                <div class="bet-inner yb-flex-center fit">
                                                    <div class="handicap-wrap">
                                                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                                                            <span class="handicap-more" style="display: none;"></span>
                                                            <div class="ellipsis"></div>
                                                        </div>
                                                    </div>
                                                    <cstgftht :event="newAllBetEvent" :score="'h_21_25'" :plyType="plytyp" :betType="bettyp" ref="h_21_25" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="handicap-item os-1">
                                            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid2">
                                                <div class="bet-inner yb-flex-center fit">
                                                    <div class="handicap-wrap">
                                                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                                                            <span class="handicap-more" style="display: none;"></span>
                                                            <div class="ellipsis"></div>
                                                        </div>
                                                    </div>
                                                    <cstgftht :event="newAllBetEvent" :score="'a_21_25'" :plyType="plytyp" :betType="bettyp" ref="a_21_25" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="handicap">
                                        <div class="handicap-item sub-title-2 yb-family-odds">
                                            {{ sportAllBetLang['ALL_BET.LBL_WIN_BY_26MORE'] }}
                                        </div>
                                        <div class="handicap-item os-1 os-wd no_border_bottom">
                                            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid2">
                                                <div class="bet-inner yb-flex-center fit">
                                                    <div class="handicap-wrap">
                                                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                                                            <span class="handicap-more" style="display: none;"></span>
                                                            <div class="ellipsis"></div>
                                                        </div>
                                                    </div>
                                                    <cstgftht :event="newAllBetEvent" :score="'h_26_x'" :plyType="plytyp" :betType="bettyp" ref="h_26_x" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="handicap-item os-1 no_border_bottom">
                                            <div class="c-bet-item yb-flex-center relative-position normal zhuanye csid2">
                                                <div class="bet-inner yb-flex-center fit">
                                                    <div class="handicap-wrap">
                                                        <div class="handicap-value yb-number-font yb-family-odds color-highlight">
                                                            <span class="handicap-more" style="display: none;"></span>
                                                            <div class="ellipsis"></div>
                                                        </div>
                                                    </div>
                                                    <cstgftht :event="newAllBetEvent" :score="'a_26_x'" :plyType="plytyp" :betType="bettyp" ref="a_26_x" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </template>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapGetters
} from 'vuex'
import OddComponents from '../../../components/odd'
import HandicapComponents from '../../../components/handicap'

import allBetMixin from '../../../mixins/allBet'

export default {
    mixins: [allBetMixin],
    props: {
        allBetEvent: null,
        plytyp: null,
        selectMarket: null,
        removeMarket: null,
        rbinfo: null,
        bettyp: null,
        myMarket: {
            type: Boolean,
            default: false
        },
        isSpecial: {
            type: Boolean,
            default: false
        },
        mode:null
    },
    data() {
        return {
            show: true,
        }
    },
    computed: {
        ...mapGetters([
            'foldopenAllBet',
            'foldopenFirstEvent'
        ]),
        newAllBetEvent() {
            // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
            return this.allBetEvent
        }
    },
    watch: {
        foldopenAllBet() {
            if(this.mode=='ab'){
                this.show = (this.$store.getters.foldopenAllBet) ? true : false;
            }
        },
        foldopenFirstEvent() {
            if(this.mode!='ab'){
                this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
            }
        }
    },
    methods: {
        getTitleCaption() {
            var team
            if (this.bettyp == this.hldsBetType) {
                team = this.newAllBetEvent.tacapt
            } else if (this.bettyp == this.aldsBetType) {
                team = this.newAllBetEvent.tbcapt
            }

            return team + this.sportAllBetLang['ALL_BET.SUBHEADER_WD']
        },
        showLeg() {
            this.show = (!this.show) ? true : false;
        },
        setToTop(d) {
            this.$parent.setToTop(d);
        },
        addToMyMarket(plytyp, bettyp) {
            if (this.selectMarket)
                this.selectMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial)
        },
        removeFromMyMarket(plytyp, bettyp) {
            if (this.removeMarket)
                this.removeMarket(this.newAllBetEvent, plytyp, bettyp, this.isSpecial)
        },
        oddsHeader() {
            var retCapt = ''
            if (this.isSpecial) {
                retCapt += this.specialLeagueCaption(this.newAllBetEvent, this.bettyp)
            }

            return retCapt
        },
        oddsTitle(score) {
            score = score.replace('_', '-')

            return this.sportAllBetLang['ALL_BET.LBL_TO_WIN_BY'] + ' ' + score
        }
    },
    mounted(){
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }else{
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    },
}
</script>


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/allBet-wd.vue